 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		70: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"pages/content/amlpolicy/pages/content/game-rules/pages/content/intellectual-property/pages/content/l/9f3ea104","2":"pages/cashbox/history/pages/cashbox/payin-error/pages/cashbox/payin-status-ext/pages/cashbox/payin-s/61fd3eac","18":"pages/index/pages/lobby/_section/pages/lobby/_section/_sub-section","20":"pages/cashbox/deposit/pages/cashbox/withdrawal","21":"pages/profile/pages/profile/bonuses/index","32":"header-c","33":"lang-ru.js","34":"lang-ua.js","35":"pages/auth/_social/cb","36":"pages/cashbox/deposit","37":"pages/cashbox/history","38":"pages/cashbox/index","39":"pages/cashbox/payin-error","40":"pages/cashbox/payin-status-ext","41":"pages/cashbox/payin-success","42":"pages/cashbox/payout-error","43":"pages/cashbox/payout-success","44":"pages/cashbox/support","45":"pages/cashbox/withdrawal","46":"pages/content/amlpolicy","47":"pages/content/faq","48":"pages/content/game-rules","49":"pages/content/intellectual-property","50":"pages/content/license","51":"pages/content/partners","52":"pages/content/privacy-policy","53":"pages/content/responsible-gaming","54":"pages/content/rules","55":"pages/error-game","56":"pages/game/_term","57":"pages/index","58":"pages/lobby/_section","59":"pages/lobby/_section/_sub-section","60":"pages/profile","61":"pages/profile/bonuses/index","62":"pages/profile/kycaid","63":"pages/profile/settings/index","64":"pages/profile/support-faq/index","65":"pages/promotions/_term","66":"pages/promotions/index","67":"pages/promotions/welcome-pack/index","68":"pages/registration","69":"pages/verifications/index","72":"vendors/pages/lobby/_section"}[chunkId]||chunkId) + "." + {"0":"2b9bc2905c9b32247da3","1":"44e34351b727e38bf2a6","2":"424abf9d78b563d095b5","3":"91e1c60a85336f50a802","4":"d98938e21938cf9b0c78","5":"283e6c83b7c711a14c11","6":"78c7c082133512ca73ea","7":"51b559002695921cf9cb","8":"560c4f6de6eecdcdb262","9":"1bab650bf22998e8e272","10":"f4de9da3151de88a2e80","11":"09443a2a02a74100598d","12":"fc2cafec24cc36762800","13":"cdb69b7bcc6e933dac30","14":"48f1aae8af686bffec9a","15":"a2b96e9072713387fc9d","16":"cefdba992030df8620de","17":"c40e6f86a157d1496962","18":"8bce325482702cfc00c1","19":"510d01f064913cbdbf1f","20":"b7ac94a7d9b010b72e49","21":"99bda80b1681dad30b0e","22":"1ffbf075b0729524ee74","23":"ae3972dd840fabfd8207","24":"f76ab915c5bf0f8ccea9","25":"3ed015e37c3b0f601c3e","26":"ad1cb9baaeea689f4f47","27":"c22603c91e00ec30aa9c","28":"c49571e3b242c22972dd","29":"d1cbe05161d8f5326f4f","32":"a6bba46e1c8ffbf7ff79","33":"242861a8f7e03cf72a9e","34":"e1b67d2d4ed15e1bd24f","35":"29e89b615d168dfb84bd","36":"69e6a9cd8a72dcd06a93","37":"886a5029c5e44ee09716","38":"ed2d75d7e90aa61e331b","39":"842020bd385c09598590","40":"4a768d1fe7e7ae8cef83","41":"33c638d12c63ef9fd0f2","42":"303e7d908053217c7e95","43":"0ee154090b3e8bb44954","44":"88b206ab345e19ef5919","45":"ac021cc685ed7d049863","46":"8de5b9d475d5b1285ddf","47":"e2ea460098f87460885c","48":"b69d173c03ee2015b6c7","49":"2c7212c39a0cf02639b7","50":"70b96e9703131221c3f1","51":"be247dcf5777c451acd8","52":"14e59339361dde853732","53":"81b2a86cde1953b1bc57","54":"950ac0bdb2aa9b485ca5","55":"8a3025089dcc9dd5f678","56":"6a040336ff0c8473449e","57":"325e3fa0dea5f206c8f1","58":"2934f7ba1f7fce536f95","59":"4a6f0f525b43856bf8a9","60":"7cd7c433b129a74577f6","61":"50fc95376189257959c8","62":"10d056eb9d615c0e1266","63":"bdc97ddcf74296a8f70a","64":"36cc9e3ef6f668ea2642","65":"86fee6ac9c0649179f09","66":"c0fbdc40d2933c63845f","67":"355a5f84f098e821e335","68":"0a36b8265dfd0b5a343b","69":"ca38609f0a017be6b2ba","72":"4a49721e1d76aa851d24","73":"3958c364e78f893a7e93","74":"33fb8a1c90e8f45edb96","75":"1b362ce2fdc5bc0cf6f3","76":"ea577830fff7f5fc8cfe","77":"e65565ba83e29fc59beb","78":"5cfb7f99614f3825b0ce","79":"13158b9c235437627f1a","80":"f57ade74adcd34d6f160","81":"16c0c0a70385f71ba5c1","82":"4f9de0bf391f670db0df","83":"3091b1e90dfcc0fdce75","84":"024acc1b18265d6a499f","85":"89ecd99329b3ec1da199","86":"ca0a13e04ebc5c785782","87":"d84f850038640ce46382","88":"7ca310f9293eff5fd886","89":"df603c0d16dd086c03de","90":"a80e3541dc6327801c43","91":"db5519b85088ebe49ad2","92":"2be708b0df863946a87f","93":"a5634002927cb3a080e6","94":"1d5b2fe8acd99728e751","95":"19c358d68d4e60e34734","96":"b7a2157fcde3aae1932a","97":"57ae6bcf6f20714109f3","98":"9823d6532faf59631968","99":"d250ac8659259ddf1195","100":"15969db6599ba84dcb82","101":"87eaad4c1a57d68c3fca","102":"73496dac47ac2c503ffb","103":"0770e1908d2723841ffb","104":"64c22a89c77aea42d555","105":"5d0a10a72b87de369f7e","106":"dc572fb65fe3779f5d3c","107":"c2ca97fa20aa396eb9fc","108":"cca39546edc19ca67108","109":"47e24abf31a62b2da313","110":"d85c0f0fabd4b316a051","111":"f40252417ef2ac646694","112":"ccb1c0cb726da1815a7c","113":"cb0f8bf3a13a4daf5f48","114":"12870117e2a89e3c95e5","115":"26e4c851016f2423896c","116":"68a4da276fce8c77414e","117":"3b7161b8a72cba3c41cd","118":"6c9d577ad92dff63ce92","119":"58f7c9d2dfe86e99d01b","120":"b140427fb0bfb98bb17b","121":"068c98cb6d2659ab7938","122":"3bf5cebb4c7cf18e3c04","123":"9bb0abbc3cfaf0cea6f3","124":"33e27aaebb8beace2433","125":"9db22d0f1fab00719e26"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
